var React = require('react');

function Dev (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"r":"256","cy":"256","cx":"256","fill":"#2c3e50","key":0}),React.createElement("path",{"d":"M160 160l-68 96 68 96","fill":"none","stroke":"#fff","strokeWidth":"32","key":1}),React.createElement("path",{"d":"M304 96l-96 320","fill":"none","stroke":"#ee3939","strokeWidth":"32","key":2}),React.createElement("path",{"d":"M352 160l68 96-68 96","fill":"none","stroke":"#fff","strokeWidth":"32","key":3})]);
}

Dev.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Dev;

Dev.default = Dev;
